(function () {
  'use strict';
  if (globalThis.SCDM_COLIS) return;
  var POIDS = {
    vinyle:        0.0116,   /* kg/pi2 = 125 g/m2 — film 80 um + adhesif 25 um */
    reflechissant: 0.0210,   /* kg/pi2 = 226 g/m2 — ⚠ NON VERIFIE, lire ci-dessous */
    alupanel:      0.3530,   /* kg/pi2 = 3 800 g/m2 — fiche DIBOND, exact */
    coroplast:     0.0697,   /* kg/pi2 = 750 g/m2 — fiche Coroplast, exact */
    /* ⚠️ LA PELLICULE DE PROTECTION — AJOUTEE LE 11 SEPTEMBRE 2026.
       Elle n etait comptee NULLE PART : un lot de 250 autocollants de
       6 x 6 po partait avec 500 g de film non declares, et un panneau du
       Repertoire, qui la porte maintenant d office, avec sa part aussi.
       Un colis sous-declare est repese au depot et refacture des semaines
       plus tard, sur une commande deja encaissee.
       0,0079 kg/pi2 = 85 g/m2 : un surlaminat polymere de 1,7 mil
       (43 um x 1,25 g/cm3 = 54 g/m2) plus son adhesif (25 um x 1,00 =
       25 g/m2) et le trait de colle. Meme reconstitution que la ligne
       « vinyle » au-dessus, qui a ete verifiee. */
    pellicule:     0.0079
  };

  /* ==================================================================
     ⚠️ LE REFLECHISSANT EST LA SEULE VALEUR NON VERIFIEE DE LA TABLE

     AUCUN FABRICANT NE PUBLIE LE POIDS AU METRE CARRE d une pellicule
     retroreflechissante. Cherche le 11 septembre 2026 : le bulletin produit
     de la 3M Engineer Grade Prismatic 3430 donne la temperature de pose et
     l angularite, mais NI EPAISSEUR NI GRAMMAGE. Les autres fabricants non
     plus.

     Le 0,0210 kg/pi2 (226 g/m2) inscrit ci-dessus est donc une ESTIMATION,
     pas une mesure. Reconstitution : une pellicule microprismatique fait de
     0,20 a 0,25 mm, en acrylique ou en polycarbonate (1,2 g/cm3), avec des
     alveoles d air scellees qui enlevent 20 a 30 % de la masse. La
     fourchette defendable va de 200 a 300 g/m2.

     LA MARGE HONNETE SUR CETTE LIGNE EST DE +/- 25 %, et non de +/- 15 %
     comme sur le reste de la table. C est la seule valeur du systeme qui ne
     repose sur aucune fiche, et elle porte sur les pieces les plus cheres du
     catalogue, les panneaux routiers.

     ⚠️ NE PAS BAISSER CETTE VALEUR TANT QU UN ROULEAU N A PAS ETE PESE. Un
     colis sous-declare est repese au depot et refacture des semaines plus
     tard, sur une commande deja encaissee : c est l atelier qui paie. Un
     colis surdeclare ne coute que la difference de palier, tout de suite, et
     le client l a acceptee en commandant. Entre les deux, on choisit
     toujours le surdeclare.

     LA PESEE : une balance de cuisine, un metre carre decoupe, dix minutes.
     ================================================================== */

  /* Le film retroreflechissant pese environ le double d un vinyle ordinaire :
     il porte une couche optique que le vinyle n a pas.
     Tout le reste de la liste est du vinyle calandre.

     LE PRISMATIQUE A ETE RETIRE LE 9 SEPTEMBRE 2026 — l atelier n en a qu un
     echantillon, pas un rouleau. Un vieux panier qui le nommerait encore
     retombe sur le poids du vinyle : quelques grammes d ecart sur un colis
     qu on ne peut de toute facon plus fabriquer. Rien ne plante. */
  function poidsMatiere(id) {
    return (id === 'reflechissant') ? POIDS.reflechissant : POIDS.vinyle;
  }

  /* Le support n est pas dans l etat du configurateur : c est scdm-panneau.js
     qui l ecrit dans les proprietes de la ligne. On lit donc le libelle, mais
     seulement pour y chercher un nom de matiere — pas une formulation. */
  /* LA PELLICULE. On lit le laminage RANGE SUR LE DESIGN (d.laminage), pas
     un libelle d affichage : scdm.js y ecrit laminageCourant().id au moment
     de l ajout, et « aucun » y veut dire « rien de coche ». Un design ajoute
     avant le 11 septembre 2026, ou un vieux panier, n a pas le champ : la
     fonction rend zero, exactement comme avant. */
  function poidsPellicule(d) {
    var l = d && d.laminage;
    return (l && l !== 'aucun') ? POIDS.pellicule : 0;
  }

  function poidsSupport(libelle) {
    var s = String(libelle || '').toLowerCase();
    if (s.indexOf('alupanel') !== -1) return POIDS.alupanel;
    if (s.indexOf('coroplast') !== -1) return POIDS.coroplast;
    return 0;
  }

  /* ==================================================================
     DU POIDS REEL AU POIDS FACTURABLE

     Releve du 6 septembre 2026 : Postes Canada, UPS, Purolator et GLS
     facturent tous LE PLUS ELEVE du poids reel et du poids volumetrique.
     Verifie sur leurs calculateurs publics — un carton de 65 x 65 x 4 cm
     coute exactement le meme prix charge a 0,3 kg ou a 1,8 kg.

     C est le piege des pancartes rigides, et il nous coutait cher. Une
     pancarte de 18 x 18 po pese 0,84 kg, mais son carton fait 50 x 50 x 4 cm,
     soit 10 600 cm3 : le transporteur facture 2,12 kg. On tombait donc dans
     un palier d expedition bien en dessous de celui que le colis demande
     reellement. Chaque pancarte rigide partait a perte.

     LE DIVISEUR EST 5 000 cm3 PAR KILO. C est celui de Postes Canada
     (Priorite, Xpresspost, Colis accelere) et le plus severe des quatre. Le
     Colis standard utilise 6 000 : en prenant 5 000 on reste du bon cote.

     POURQUOI ON NE PEUT PAS SIMPLEMENT ENVOYER LES DIMENSIONS. Shopify ne
     recoit aucune dimension de colis depuis le panier — il prend celles du
     colis par defaut configure dans les reglages. On plie donc le volume
     DANS le poids : le poids facturable fait exactement le travail, autant
     sur des paliers manuels que sur des tarifs calcules en direct.
     CONSEQUENCE A RETENIR : le colis par defaut dans les reglages Shopify
     doit rester PETIT, sinon le volume serait compte deux fois.

     TROIS EMBALLAGES, parce qu un vinyle se roule et qu une pancarte non.
     Un decal de 24 x 36 po part dans un tube et vaut 1,3 kg facturable ; la
     meme surface sur alupanel part a plat et en vaut 3,5. */

  var DIVISEUR_VOL = 5000;                              /* cm3 par kg */
  var PO_EN_CM = 2.54;
  var EP_SUPPORT = { alupanel: 0.3, coroplast: 0.4 };   /* cm */

  /* ==================================================================
     L EMBALLAGE — UNE SURFACE, PAS UN FORFAIT

     CE QUI N ALLAIT PAS, MESURE LE 11 SEPTEMBRE 2026. Le forfait valait
     0,30 kg par caisse plus 0,05 kg par piece, quelle que soit la grandeur.
     Or une caisse, c est une SURFACE de carton, et une surface grandit avec
     le CARRE du cote. Le forfait etait donc faux AUX DEUX BOUTS :

       6 x 6 po   : carton reel    126 g  contre 350 g annonces -> +224 g de trop
       12 x 18 po : carton reel    473 g  contre 350 g          ->  -123 g
       24 x 36 po : carton reel  1 507 g  contre 350 g          -> -1 157 g
       36 x 36 po : carton reel  2 549 g  contre 350 g          -> -2 199 g
       48 x 48 po : carton reel  4 352 g  contre 350 g          -> -4 002 g

     Quatre kilos manquants sur un 48 x 48. Le transporteur repese le colis
     au depot et refacture des semaines plus tard, sur une commande deja
     encaissee.

     LA FORMULE. Developpe d une caisse a rabats :
       surface (cm2) = [ 2 x (L + l) + patte ] x (h + l)
     multiplie par le grammage du carton ondule simple cannelure C, 32 ECT
     (42#/26#/42# = 592 g/m2), puis par 1,10 pour la colle, le ruban et
     l encre.

     ON AJOUTE : 32 g de coins de protection des que le grand cote atteint
     18 po, et deux tours de film etirable de 20 cm de large (80 gauge,
     18,4 g/m2) autour de la ceinture.

     LE TUBE suit la meme logique, un volume de paroi kraft :
       poids (kg) = pi x (5^2 - 4,8^2) x longueur_cm x 0,70 / 1000 + 0,020
     soit une paroi de 2 mm a 0,70 g/cm3, plus deux bouchons de 10 g. Le
     forfait de 0,25 kg valait pour un tube de 21 cm ; un tube de 48 po en
     fait 127 et pese 567 g.

     L ENVELOPPE RIGIDE RESTE A 0,10 KG FORFAITAIRE. Le reel est de 37 g sur
     un 6 x 6 po : elle SURDECLARE, donc elle joue du bon bord. On n y touche
     pas.
     ================================================================== */

  var CARTON = {
    grammage: 0.592,    /* kg/m2 — carton ondule simple cannelure C, 32 ECT */
    majoration: 1.10,   /* colle, ruban, encre */
    patte: 4,           /* cm — la patte de collage du developpe */
    coins: 0.032,       /* kg — des que le grand cote atteint 18 po */
    coinsDes: 18,       /* po */
    film: 0.0184,       /* kg/m2 — film etirable 80 gauge (20 um, LLDPE) */
    filmLarge: 0.20,    /* m — largeur de la bande */
    filmTours: 2
  };

  var EMBALLAGE = {
    enveloppe: { marge: 2, epaisseur: 2, poids: 0.10 },
    tube:      { marge: 5, diametre: 10 },
    boite:     { marge: 4, epaisseur: 4 }
  };

  /* Le carton d une boite plate de L x l x h (cm). « grandPo » est le grand
     cote de la piece, en pouces : il decide des coins de protection. */
  function poidsCarton(L, l, h, grandPo) {
    var surface = (2 * (L + l) + CARTON.patte) * (h + l);       /* cm2 */
    var kg = surface / 10000 * CARTON.grammage * CARTON.majoration;
    if (grandPo >= CARTON.coinsDes) kg += CARTON.coins;
    var ceinture = 2 * (l + h) / 100;                           /* m */
    kg += ceinture * CARTON.filmLarge * CARTON.filmTours * CARTON.film;
    return kg;
  }

  /* Le tube kraft : diametre exterieur 10 cm, paroi de 2 mm, plus les deux
     bouchons. La longueur est celle du tube, en centimetres. */
  function poidsTube(longueurCm) {
    return Math.PI * (25 - 23.04) * longueurCm * 0.70 / 1000 + 0.020;
  }

  /* Les cotes de la piece, en pouces. scdm.js les ecrit en toutes lettres
     dans « Grandeur réelle » (« 18 po × 18 po »). Si la ligne manque, on
     retombe sur un carre de meme surface — jamais sur zero. */
  function cotesDe(d) {
    if (d.dimensionsPo && Number.isFinite(d.dimensionsPo.L) && Number.isFinite(d.dimensionsPo.H) && d.dimensionsPo.L > 0 && d.dimensionsPo.H > 0) return { petit: Math.min(d.dimensionsPo.L, d.dimensionsPo.H), grand: Math.max(d.dimensionsPo.L, d.dimensionsPo.H) };
    var t = String((d.props && d.props['Grandeur réelle']) || '');
    var m = t.match(/([\d.,]+)\s*po\s*[x×]\s*([\d.,]+)\s*po/i);
    var l = m ? parseFloat(m[1].replace(',', '.')) : 0;
    var h = m ? parseFloat(m[2].replace(',', '.')) : 0;
    if (!(l > 0 && h > 0)) { l = h = Math.sqrt(Number(d.aire) || 0); }
    return { petit: Math.min(l, h), grand: Math.max(l, h) };
  }

  function epaisseurSupport(libelle) {
    var s = String(libelle || '').toLowerCase();
    if (s.indexOf('alupanel') !== -1) return EP_SUPPORT.alupanel;
    if (s.indexOf('coroplast') !== -1) return EP_SUPPORT.coroplast;
    return 0;
  }

  function poidsNetDe(d) {
    var pi2 = (Number(d.aire) || 0) / 144;
    if (!(pi2 > 0)) return 0;
    var parPiece = poidsMatiere(d.matiere) +
                   poidsSupport(d.props && d.props['Support']) +
                   poidsPellicule(d);
    return pi2 * parPiece * (Number(d.qte) || 1);
  }

  function cmDe(po) { return po * PO_EN_CM; }
  function nb1(n) { return n.toFixed(1).replace('.', ','); }
  function nb2(n) { return n.toFixed(2).replace('.', ','); }

  /* ==================================================================
     LES COLIS - COMBIEN, ET DE QUELLE GRANDEUR

     CE QUI N ALLAIT PAS. La version precedente mettait TOUTE la commande
     dans UN SEUL carton. Sur une commande ordinaire ca ne se voyait pas ;
     sur une vraie commande d atelier, ca donnait n importe quoi :

       50 panneaux 24 x 36 po sur alupanel
         -> « une boite de 95 x 65 x 19 cm, 115 kg »

     Aucun transporteur ne prend ca : Postes Canada plafonne a 30 kg. Le
     bordereau annoncait donc un colis impossible a faire, et le poids
     facturable etait calcule sur un carton qui n existerait jamais.

     LES LIMITES, relevees le 9 septembre 2026 chez Postes Canada - le plus
     severe des quatre transporteurs, donc celui qui nous garde du bon cote :

       30 kg par colis
       2 m sur le plus grand cote
       longueur + ceinture <= 3 m,  ceinture = 2 x (largeur + hauteur)
       supplement « surdimensionne » des qu un cote depasse 1 m,
         ou que le DEUXIEME plus grand cote depasse 76 cm

     ⚠️ CE DERNIER SEUIL MORD PLUS TOT QU ON PENSE. Un panneau de 36 x 36 po
     fait 95 cm de cote une fois emballe : son deuxieme plus grand cote
     depasse 76 cm, donc CHAQUE colis paie le supplement. Et la regle de
     ceinture n en laisse passer que deux par carton. Dix panneaux de
     36 x 36, c est cinq colis surdimensionnes - pas un.

     ON REMPLIT LES CARTONS PIECE PAR PIECE, et on en ouvre un nouveau des
     que le suivant ferait depasser le poids ou la ceinture. C est exact
     meme quand la commande melange des grandeurs et des matieres, ce qu un
     calcul par moyenne ne saurait pas faire.

     ON S ARRETE UN PEU AVANT LA LIMITE : 29,5 kg au lieu de 30, et 296 cm
     de ceinture au lieu de 300. Un carton n a jamais le poids ni la
     hauteur exacts qu on a calcules, et un colis refuse au comptoir coute
     une journee.

     LE POIDS FACTURABLE EST LA SOMME DES COLIS, chacun au plus eleve de son
     poids reel et de son poids volumetrique. C est exactement ce que le
     transporteur facture.
     ================================================================== */

  /* ==================================================================
     ⚠️ LE COLIS LOURD PART EN SOUMISSION — 11 septembre 2026

     Decision du proprietaire. C est la question laissee ouverte au §2.2 de
     claude/EXPEDITION-travaux.md.

     LE SEUIL N EST PAS INVENTE : il est deja trace dans la grille Shopify.
     Paliers Quebec-Ontario, releves le 11 septembre 2026 :

       0      a 0,3 kg   13 $      0,301 a 2 kg     19 $
       2,001  a 8 kg     32 $      8,001 a 20 kg    55 $
       20,001 kg et plus 110 $   <- le seul palier SANS plafond

     Les quatre premiers disent le prix d un intervalle connu. Le cinquieme
     demande 110 $ a un colis de 20,1 kg comme a un colis de 29,5 kg — au
     dela, il faut un deuxieme carton et on est deja hors grille. Un prix
     plat etale sur 9,5 kg n est pas un tarif : le kilo de plus y rapporte
     ZERO alors que tous les transporteurs le facturent, surcharge carburant
     comprise (41 % Postes Canada, 45,5 % Purolator, 49,5 % FedEx, semaine
     du 14 septembre 2026).

     ET CE PALIER N A JAMAIS ETE CONCU POUR PORTER CA. Avant la correction
     de l emballage du 11 septembre, 200 pancartes de 12 x 18 po partaient
     en soumission : l ancien forfait ajoutait 10 kg de carton imaginaire,
     donc deux colis. Le carton reel pese 1,38 kg, elles tiennent dans UN
     carton de 28,8 kg, et la commande s est mise a passer a la caisse. Par
     accident de calcul, pas par decision. Le seuil la remet ou elle etait.

     LE RAMASSAGE RESTE OFFERT, et c est la condition de la decision : voir
     proposerLeChoix(). POUR DEPLACER LE SEUIL, le nombre ci-dessous et lui
     seul ; zero ou negatif desactive la bascule.
     ================================================================== */
  var SEUIL_LOURD_KG = 20;

  var LIM = {
    poids: 29.5,      /* kg par colis - la limite reelle est 30 */
    cote: 200,        /* cm sur le plus grand cote */
    ceinture: 296,    /* cm - la limite reelle est 300 */
    surCote: 100,     /* cm : au-dela, supplement « surdimensionne » */
    surSecond: 76     /* cm sur le deuxieme plus grand cote, meme supplement */
  };

  function ceintureDe(L, l, h) {
    var t = [L, l, h].sort(function (a, b) { return b - a; });
    return t[0] + 2 * (t[1] + t[2]);
  }

  function surdimensionne(L, l, h) {
    var t = [L, l, h].sort(function (a, b) { return b - a; });
    return t[0] > LIM.surCote || t[1] > LIM.surSecond;
  }

  function colisDe(commande) {
    var grand = 0, petit = 0, poidsSouple = 0, rigides = [];

    commande.forEach(function (d) {
      var c = cotesDe(d);
      if (c.grand > grand) grand = c.grand;
      if (c.petit > petit) petit = c.petit;
      var q = Math.max(1, Number(d.qte) || 1);
      var pi2 = (Number(d.aire) || 0) / 144;
      var sup = d.props && d.props['Support'];
      var ep = epaisseurSupport(sup);
      var parPiece = pi2 * (poidsMatiere(d.matiere) + poidsSupport(sup) + poidsPellicule(d));
      if (ep > 0) {
        /* On borne l expansion : personne ne commande 5 000 panneaux
           rigides, et une boucle sans borne bloquerait la page. */
        for (var i = 0; i < Math.min(q, 5000); i++) rigides.push({ p: parPiece, e: ep });
      } else {
        poidsSouple += parPiece * q;
      }
    });

    if (!rigides.length && !(poidsSouple > 0)) return { grammes: 0, libelle: '', nb: 0, surdim: 0, horsGrille: false, lourd: false };

    var colis = [], alertes = [];

    if (rigides.length) {
      var emb = EMBALLAGE.boite;
      var L = cmDe(grand) + emb.marge, l = cmDe(petit) + emb.marge;
      /* la hauteur que la ceinture autorise encore, une fois L et l poses */
      var hMax = Math.min(LIM.cote, (LIM.ceinture - L - 2 * l) / 2);
      if (L > LIM.cote) alertes.push('une pièce dépasse 2 m — Postes Canada refuse');

      /* ⚠️ LE CARTON NE PEUT PLUS ETRE POSE D AVANCE. Son poids depend de la
         HAUTEUR FINALE de la caisse, donc du nombre de pieces qu on y aura
         mises : on empile d abord le contenu dans « net », et on ajoute le
         carton au moment ou la caisse se ferme. Le test de poids, lui, doit
         anticiper — il compte le carton que la caisse AURAIT une fois la
         piece suivante ajoutee, sinon on depasserait la limite. */
      var b = null;
      var fermer = function (c) {
        c.net += poidsCarton(c.L, c.l, c.h, grand);
        colis.push(c);
      };
      rigides.forEach(function (p) {
        if (b) {
          var hApres = b.h + p.e;
          var lourd = b.net + p.p + poidsCarton(L, l, hApres, grand) > LIM.poids;
          /* Math.max garantit au moins une piece par carton : mieux vaut un
             colis hors norme signale qu une boucle qui n avance jamais. */
          var epais = hApres > Math.max(emb.epaisseur + p.e, hMax);
          if (lourd || epais) { fermer(b); b = null; }
        }
        if (!b) b = { forme: 'Boîte plate', L: L, l: l, h: emb.epaisseur, net: 0, n: 0 };
        b.net += p.p; b.h += p.e; b.n++;
      });
      if (b) fermer(b);
      if (colis.length) colis[0].net += poidsSouple;   /* le souple voyage avec */

    } else {
      var enTube = petit > 12;
      var e2 = enTube ? EMBALLAGE.tube : EMBALLAGE.enveloppe;
      var f2 = enTube ? 'Tube' : 'Enveloppe rigide';
      var L2 = enTube ? cmDe(petit) + e2.marge : cmDe(grand) + e2.marge;
      var l2 = enTube ? e2.diametre : cmDe(petit) + e2.marge;
      var h2 = enTube ? e2.diametre : e2.epaisseur;
      if (L2 > LIM.cote) alertes.push('une pièce dépasse 2 m — Postes Canada refuse');
      /* Le tube se calcule sur sa longueur reelle ; l enveloppe garde son
         forfait de 0,10 kg, qui surdeclare et joue du bon bord. */
      var pEmb = enTube ? poidsTube(L2) : e2.poids;
      var reste = poidsSouple + pEmb;
      while (reste > 0 && colis.length < 40) {
        var part = Math.min(reste, LIM.poids);
        colis.push({ forme: f2, L: L2, l: l2, h: h2, net: part, n: 0 });
        reste -= part;
      }
    }

    var net = 0, vol = 0, fact = 0, surdim = 0;
    colis.forEach(function (c) {
      c.vol = (c.L * c.l * c.h) / DIVISEUR_VOL;
      net += c.net; vol += c.vol;
      fact += Math.max(c.net, c.vol);
      if (surdimensionne(c.L, c.l, c.h)) surdim++;
      if (ceintureDe(c.L, c.l, c.h) > 300) alertes.push('un colis dépasse la ceinture de 3 m');
    });

    var p0 = colis[0], dernier = colis[colis.length - 1];
    var lib = (colis.length > 1 ? colis.length + ' × ' : '') +
      (colis.length > 1 ? p0.forme.toLowerCase() : p0.forme) + ' ' +
      nb1(p0.L) + ' × ' + nb1(p0.l) + ' × ' + nb1(p0.h) + ' cm' +
      (colis.length > 1 ? ' (le dernier ' + nb1(dernier.h) + ' cm)' : '') +
      ' · réel ' + nb2(net) + ' kg · volumétrique ' + nb2(vol) + ' kg';
    if (surdim) lib += ' · ' + surdim + ' colis surdimensionné' + (surdim > 1 ? 's' : '');
    if (alertes.length) {
      var vues = [];
      alertes.forEach(function (a) { if (vues.indexOf(a) < 0) vues.push(a); });
      lib += ' · ⚠ ' + vues.join(' ; ');
    }

    return {
      grammes: Math.round(fact * 1000),
      libelle: lib,
      nb: colis.length,
      surdim: surdim,
      /* ⚠️ HORS GRILLE : plus d un colis, OU un colis surdimensionne.
         C est exactement l ensemble des cas ou les 18 paliers ne savent
         pas dire le vrai prix - decision du proprietaire, 9 septembre.
         Ces commandes-la ne vont pas a la caisse : elles partent en
         soumission, le transport est confirme aupres du transporteur,
         puis une facture provisoire Shopify porte le vrai montant. */
      horsGrille: (colis.length > 1 || surdim > 0),
      /* ⚠️ LOURD : un seul colis, aux bonnes dimensions, mais au-dela du
         dernier palier borne de la grille. Voir SEUIL_LOURD_KG. Ce n est
         PAS « horsGrille » : le client garde le droit de poursuivre vers la
         caisse s il ramasse a l atelier. C est envoyer() qui tranche. */
      lourd: (SEUIL_LOURD_KG > 0 && fact > SEUIL_LOURD_KG)
    };
  }


  function descriptor(d, group, index) {
    var dims = d && d.dimensionsPo;
    var support = String(d && d.props && d.props['Support'] || '').toLowerCase();
    var value = { v: 1, group: group, design: String(index), L: dims && dims.L, H: dims && dims.H,
      aire: d && d.aire, qte: d && d.qte, matiere: d && d.matiere,
      laminage: d && d.laminage || 'aucun',
      support: support.indexOf('alupanel') !== -1 ? 'alupanel' : support.indexOf('coroplast') !== -1 ? 'coroplast' : 'aucun' };
    decode(value);
    return value;
  }
  function decode(raw) {
    var p = typeof raw === 'string' ? JSON.parse(raw) : raw;
    if (!p || p.v !== 1 || typeof p.group !== 'string' || !/^[a-zA-Z0-9_-]{1,100}$/.test(p.group) ||
      typeof p.design !== 'string' || p.design.length > 30 ||
      !Number.isFinite(p.L) || !Number.isFinite(p.H) || p.L <= 0 || p.H <= 0 || p.L > 240 || p.H > 240 ||
      !Number.isFinite(p.aire) || p.aire <= 0 || p.aire > 57600 ||
      !Number.isInteger(p.qte) || p.qte < 1 || p.qte > 10000 ||
      typeof p.matiere !== 'string' || !/^[a-zA-Z0-9_-]{1,50}$/.test(p.matiere) ||
      typeof p.laminage !== 'string' || !/^[a-zA-Z0-9_-]{1,50}$/.test(p.laminage) ||
      !['aucun', 'alupanel', 'coroplast'].includes(p.support)) throw new Error('SCDM_SHIPPING_RECONFIGURE');
    return { dimensionsPo: { L: p.L, H: p.H }, aire: p.aire, qte: p.qte, matiere: p.matiere,
      laminage: p.laminage, props: { Support: p.support }, shippingGroup: p.group };
  }
  function weightProperties(colis, ramasse, group, count) {
    var props = {
      '_scdm_shipping_group': group, '_scdm_shipping_count': String(count),
      'Détail': 'Poids facturable — ' + nb2(colis.grammes / 1000) + ' kg' + (colis.nb > 1 ? ' · ' + colis.nb + ' colis' : ''),
      'Colis suggéré': colis.libelle
    };
    if (ramasse) props['Expédition'] = 'Ramassage à l’atelier d’Alma choisi au configurateur — colis de ' +
      nb2(colis.grammes / 1000) + ' kg. Si la commande part en livraison, le tarif de transport doit être revérifié avant l’expédition.';
    return props;
  }
  globalThis.SCDM_COLIS = Object.freeze({ colisDe: colisDe, descriptor: descriptor, decode: decode,
    weightProperties: weightProperties, seuilLourdKg: SEUIL_LOURD_KG });

})();
